import React, {useEffect, useState} from 'react';
import axios from 'axios';
import dayjs from "dayjs";
import NumberFormat from "react-number-format";



const InfoBox = ({title, value,mini=false, danger=false})=><div className={`border p-2  rounded shadow-md bg-gray-100 ${danger ? 'bg-red-100' : ''}`}>
    <div className="text-gray-500 text-sm" >{title}</div>
    <div className={` ${mini?'text-lg ':'text-2xl '}`} >{value}</div>
</div>

  export default function CustomerAnalyzerPage(props) {

    const [data, setData] = useState(null);
    const [loading, setLoading]=useState(false);


    useEffect( () => {

        console.log("request para cliente id");
        if(props.match.params.id) getData(props.match.params.id);
      }, [props.match.params.id])




      const getData=(id)=>{

        setLoading(true);
        axios.get(  process.env.REACT_APP_API_ENDPOINT + `delivery/customerAnalyzer/${id}` ).then(
          (result)=>{
             console.log( "result axios counter", result);
             setData(result.data);
             setLoading(false);

          }
      ).catch( e=>         setLoading(false)      );  

      }

      const marcarComoSospechoso = (idCliente) => {
        if(!idCliente) return;
        const confirmado = window.confirm('Desea marcar este cliente como sospechoso?');
        if(!confirmado) return;

        axios.post( process.env.REACT_APP_API_ENDPOINT + `delivery/customerAnalyzer/sospechoso/${idCliente}` )
          .then(() => {
            getData(idCliente);
          })
          .catch(() => {});
      }


      if(loading) return <div>Loading...</div>
      if(!data?.cliente) return <div>Loading...</div>


    return (
        <div className="overflow-scroll w-full  p-5 gap-5 flex flex-col">


<div className={`flex flex-col gap-2 items-start p-3 ${data.cliente.sospechoso===1 ? 'bg-red-600' : 'bg-white'}`}>
  
      <div className="flex flex-col ">
        <h2 className={`text-2xl font-bold `}>Análisis de:</h2>
        <h4 className={`text-xl font-bold `}>{data.cliente.nombre || "sin nombre" } </h4>
        <h4 className={`text-xl font-bold `}>{data.cliente.email} </h4>
      </div>

      <div className="flex flex-col gap-1">
      {
        data.cliente.sospechoso===1 &&
            <div className="px-2 py-1 border border-black w-fit rounded-sm">
            MARCADO COMO SOSPECHOSO
          </div>
      }
      {
        data.cliente.deleted_at &&
            <div className="px-2 py-1 border border-black w-fit rounded-sm">
            Borrado el {dayjs(data.cliente.deleted_at).format('DD/MM/YYYY HH:mm:ss')}
          </div>
      }
      </div>

        { data.cliente.sospechoso===0 && <button
          className="bg-red-600 text-white px-3 py-2 rounded w-fit disabled:opacity-50"
          onClick={() => marcarComoSospechoso(data?.cliente?.id )}
          // disabled={data.cliente.sospechoso===1}
        >
          MARCAR COMO SOSPECHOSO
        </button>}

</div>



{/* <pre>
  {JSON.stringify(data.cliente, null, 2)}
</pre> */}

<div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
  <InfoBox mini title="Registrado el " value={`${dayjs(data.cliente.created_at).format('DD/MM/YYYY HH:mm:ss')}`} />
<InfoBox mini title="Celular" value={data.cliente.celular} />
<InfoBox mini title="Email" value={data.cliente.email} />
</div>



<div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
  <InfoBox title="Pedidos totales" value={data.orders} />
<InfoBox title="Pedidos hoy" value={data.ordersToday} />
<InfoBox title="Pedidos en la ultima hora" value={data.ordersLastHour}  danger={data.ordersLastHour > 2} />
{data.ordersLastHour>1  && <InfoBox title="Minutos promedio entre pedidos" value={data.averageTimeBetweenOrdersToday}  danger={data.averageTimeBetweenOrdersToday < 5} />}
</div>


<div className="p-2 rounded-sm bg-white">
  <p>Pedidos recientes</p>
<table className="table-auto w-full mt-5">
<thead>
<tr className="bg-indigo-200">
<th className="px-2 py-2">#</th>
<th className="px-2 py-2">Fecha</th>
<th className="px-2 py-2">IP</th>
<th className="px-2 py-2">Canal</th>
<th className="px-2 py-2">Id</th>
<th className="px-2 py-2">Ticket</th>
<th className="px-2 py-2">Monto</th>
<th className="px-2 py-2">Forma de pago</th>

<th className="px-2 py-2">Sucursal</th>
<th className="px-2 py-2">Estado</th>
<th className="px-2 py-2">Tomado por</th>
</tr>
</thead>
<tbody>

{
data.recentOrders && data.recentOrders.map ((item,i)=>

<tr className="bg-gray-100"  key={item._id} >
<td className="border px-1 py-1"> { i+1 } </td>

<td className="border px-1 py-1">  { dayjs(item.created_at).format('DD/MM/YYYY HH:mm:ss') }   </td>
<td className="border px-1 py-1">{item.ip}</td>
<td className="border px-1 py-1">{item.canal}</td>
<td className="border px-1 py-1">
  

  <a 
      href={`/pedidos/${item._id}`} target="_blank" rel="noreferrer"
  >

  {item._id}
  </a>

</td>
  <td className="border px-1 py-1"> {item.ticket} </td>
<td className="border px-1 py-1 text-right">   
                      <NumberFormat value={item.total} displayType={'text'} thousandSeparator={true} decimalScale={0}
                                prefix={'Gs. '}/>
   </td>
<td className="border px-1 py-1"> {item.formaPago} </td>
<td className="border px-1 py-1"> {item.sucursal} </td>
<td className="border px-1 py-1"> {item.estado} </td>
<td className="border px-1 py-1"> {item.tomado ? item.tomado.name: 'app cliente'} </td>

</tr>

)
}
</tbody>
</table>
</div>

<div className="p-2 rounded-sm bg-white">
  <p>Pagos online recientes</p>
<table className="table-auto w-full mt-5">
<thead>
<tr className="bg-indigo-200">
<th className="px-2 py-2">#</th>
<th className="px-2 py-2">Fecha</th>
<th className="px-2 py-2">Id</th>
<th className="px-2 py-2">Pedido</th>
<th className="px-2 py-2">Monto</th>
<th className="px-2 py-2">Descripción Resp</th>
<th className="px-2 py-2">Estado</th>
</tr>
</thead>
<tbody>

{
data.last10pagos && data.last10pagos.map ((item,i)=>{

  let metadata = null;
  try{
     metadata = item.response ? JSON.parse(item.response) : null;
  }catch(e){

  }

return <tr className="bg-gray-100"  key={item.id} >
<td className="border px-1 py-1"> { i+1 } </td>

<td className="border px-1 py-1">  { dayjs(item.created_at).format('DD/MM/YYYY HH:mm:ss') }   </td>
<td className="border px-1 py-1"> { item.id } </td>
<td className="border px-1 py-1">
  <a 
      href={`/pedidos/${item.pedido_id}`} target="_blank" rel="noreferrer"
  >

  {item.pedido_id}
  </a>

</td>
<td className="border px-1 py-1 text-right">     

                    <NumberFormat value={item.monto} displayType={'text'} thousandSeparator={true} decimalScale={0}
                                prefix={'Gs. '}/>
    </td>

<td className="border px-1 py-1">{metadata?.response_description}</td>


<td 
className={`border px-1 py-1 uppercase ${item.estado==='rechazado'&&'bg-red-500'}   ${item.estado==='espera'&&'bg-yellow-200'}`}
> {item.estado} </td>

</tr>
}
)
}
</tbody>
</table>
</div>




            {/* <pre>
             DATA:   {
                JSON.stringify(data, null, 2)
             }
            </pre> */}




        </div>
    )
}


